export default {
  chatBotPopup: false,
  workTimePopup: false,
  addValidationPopup: false,
  notificationPanelPopup: false,
  addProductPopup: false,
  addProductTypePopup: false,
  addRedemptionInstructionsPopup: false,
  openProductCouponsListModal: false,
  openProductMintableContractDetailsModal: false,
};
